import classNames from 'classnames'

import { backgrounds, borders, colors } from '@/styles/shared/button'

type ButtonProps = {
  text?: React.ReactNode
  size?: string
  color?: keyof typeof colors
  pyValue?: string
  background?: keyof typeof backgrounds
  disabled?: boolean
  className?: React.ComponentProps<'div'>['className']
  border?: keyof typeof borders
  onClick?: () => void
}

const Button = ({ text, background, size, color, onClick, disabled, pyValue, border, className }: ButtonProps) => {
  return (
    <button
      type="button"
      className={classNames(
        'whitespace-pre-line',
        pyValue ?? 'py-4',
        size || 'btn-full',
        className,
        disabled ? backgrounds['bg020'] : background ? backgrounds[background] : '',
        disabled ? colors['text050'] : color ? colors[color] : '',
        disabled ? '' : 'hover:brightness-90',
        border ? `border ${borders[border]}` : '',
        'transition duration-200'
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </button>
  )
}

export default Button
